import { Stack, Typography } from "@mui/material";
import type { ShowCaughtErrorProps } from "../model";

export const ShowCaughtErrorUi = ({ error }: ShowCaughtErrorProps) => {
  return (
    <Stack>
      <Typography>エラーが発生しました: {error.message}</Typography>
    </Stack>
  );
};
